import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import { Link } from 'react-router-dom';

const FileDownloadIcon = ({file, viewFileName, iconSize, fontColor="#fff"}) => {
   
  if (file) {
    return (
      <>
        <Link to={process.env.REACT_APP_API_URL+"/api/download/"+file.id} /*style={{color:fontColor}} onClick={() => {downloadBtnClick(file)}}*/><AssignmentReturnedIcon fontSize={iconSize} /> {viewFileName && file.originFile}</Link>
      </>
    )
  }
}

export default FileDownloadIcon;